import { useRef, useState } from "react";

import Style from "./GenericInputFileWithPreviewStyle";
import InputFile from "../InputFile/InputFile";
import { FaTrash } from "react-icons/fa";
import { bytesToHuman, truncateString } from "../../utils";

export const GenericInputFileWithPreview = ({ id, name, label, acceptedMimeTypes, alt, fileUrl = "",
  disabled = false, deleted = false, OnChange, OnRemove, file = {} as File }) => {

  const [fileSelected, setFileSelected] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  function changeFileSelected(event) {
    console.log("Event: ", event.target.files[0]);
    const file = event.target.files[0];
    setFileSelected(file !== undefined);
    OnChange(event);
  };
  function onRemove(e: React.MouseEvent) {
    e.preventDefault();
    if (fileInputRef.current)
      fileInputRef.current.value = "";

    if (OnRemove)
      OnRemove();
  }

  const fileNameToUse = fileSelected && file.name ? file.name : fileUrl;
  const truncatedName = fileNameToUse ? truncateString(fileNameToUse, 25, 3) : null;

  return (
    <Style>
      <div className="main">
        <div>
          <InputFile
            id={id}
            name={name}
            disabled={disabled}
            text={label}
            accept={acceptedMimeTypes}
            onChange={changeFileSelected}
            ref={fileInputRef}
          />
        </div>
        {!deleted && fileNameToUse && (
          <div className="preview-parent">
            <div className="preview-left">
              <p className="file-name">
                {fileNameToUse.length <= 25 ? fileNameToUse :
                  <>
                    {truncatedName?.baseString}<span className="ellipsis">...</span>{truncatedName?.extension}
                  </>
                }
              </p>
              {file.size && <p className="file-size">{bytesToHuman(file.size)}</p>}
            </div>
            <button className="trash clickableEffects" onClick={onRemove}>
              <FaTrash />
            </button>
          </div>
        )}
        {deleted && fileUrl && <label className="removeLabel" >Clique em editar para confirmar!</label>}
      </div>
    </Style>
  );
}
